<div class="row" *ngIf="exibirTela">
    <div class="col-md-8 vcenter" style="text-align: center; height: 300px;">
        <div class="row" style="margin-top: 90px;">
            <div>
                <span class="titulo1">Normas</span><br/>
                <span class="titulo2">Administração</span>
            </div>
        </div>
    </div>
    <div class="col-md-4 vcenter">
        <div class="row">
            <div class="col-sm-10 margem-superior-15 borda-superior">
                <h2 style="font-weight: 600;">Acessar com certificado digital</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8">
                <a [href]="urlCertificado">
                    <img src="assets/imagens/certificado.png" alt="Login com certificado digital">
                </a>
            </div>
        </div>
    </div>
</div>
